/**
 * readmore.js — thu gọn mô tả dài, thêm nút "Xem thêm" / "Thu gọn".
 *
 * Markup: [data-readmore] > [data-readmore-body] + button[data-readmore-toggle][hidden]
 *         (nhãn nút trong [data-readmore-label])
 * Phần cắt do CSS lo (.readmore.is-clamped cắt chiều cao + lớp mờ cuối), JS chỉ đo:
 * nội dung ngắn hơn khung thì không gắn .is-clamped và nút vẫn ẩn — không có nút thừa.
 * Không có JS thì mô tả hiện đầy đủ, vì vậy việc cắt chỉ bắt đầu khi JS gắn class.
 *
 * Mô tả nằm trong tab: panel đang hidden đo ra 0 nên đo lại khi tab đổi (sự kiện
 * tabs:change của js/tabs.js) và khi đổi cỡ cửa sổ.
 *
 * WP: the_content() của sản phẩm in vào [data-readmore-body]; giữ nguyên file này.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var MORE = 'Xem thêm';
    var LESS = 'Thu gọn';
    var HEADER_OFFSET = 140;

    var blocks = [].slice.call(document.querySelectorAll('[data-readmore]'));
    if (!blocks.length) return;

    blocks.forEach(function (block) {
        var body = block.querySelector('[data-readmore-body]');
        var toggle = block.querySelector('[data-readmore-toggle]');
        var label = block.querySelector('[data-readmore-label]') || toggle;
        if (!body || !toggle) return;

        function measure() {
            // Đang mở rộng thì giữ nguyên, chỉ đo ở trạng thái thu gọn
            if (block.classList.contains('is-expanded')) return;
            if (!body.offsetParent) return; // panel tab đang ẩn — đo lúc hiện ra

            block.classList.add('is-clamped');
            var overflowing = body.scrollHeight - body.clientHeight > 8;
            block.classList.toggle('is-clamped', overflowing);
            toggle.hidden = !overflowing;
        }

        toggle.addEventListener('click', function () {
            var expanded = !block.classList.contains('is-expanded');
            block.classList.toggle('is-expanded', expanded);
            toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            label.textContent = expanded ? LESS : MORE;

            // Thu gọn khi đã cuộn quá đầu đoạn: kéo về đầu để không bị "lạc" giữa trang.
            // Trừ HEADER_OFFSET vì header dính (64 + 52px) sẽ che mất dòng đầu.
            var top = block.getBoundingClientRect().top;
            if (!expanded && top < HEADER_OFFSET) {
                window.scrollTo(0, window.pageYOffset + top - HEADER_OFFSET);
            }
        });

        var timer;
        window.addEventListener('resize', function () {
            window.clearTimeout(timer);
            timer = window.setTimeout(measure, 150);
        });

        document.addEventListener('tabs:change', function () {
            window.setTimeout(measure, 0);
        });

        // Font web về muộn làm chữ cao hơn — đo lại khi trang tải xong
        window.addEventListener('load', measure);
        measure();
    });
})();
